<template>
  <v-img
      :src="url"
      lazy-src="../../assets/img/user.png"
      contain
      @error="onError"
      class="white"
  />
</template>

<script>
export default {
  name: "PoliticianImage",
  props: {
    src: String
  },
  data() {
    return {
      failed: false
    }
  },
  watch: {
    src: function () {
      this.failed = false;
    }
  },
  computed: {
    url: function () {
      return (this.failed || !this.src) ? require("../../assets/img/user.png") : this.src;
    }
  },
  methods: {
    onError: function () {
      this.failed = true;
    }
  }
}
</script>

<style scoped>
.v-image >>> .v-image__image--preload {
  filter: none !important;
}
</style>